/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
import { Signer, utils, Contract, ContractFactory, Overrides } from "ethers";
import type { Provider, TransactionRequest } from "@ethersproject/providers";
import type { PromiseOrValue } from "../../common";
import type {
  WBANTokenWithPermit,
  WBANTokenWithPermitInterface,
} from "../../contracts/WBANTokenWithPermit";

const _abi = [
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "owner",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "spender",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "value",
        type: "uint256",
      },
    ],
    name: "Approval",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "uint8",
        name: "version",
        type: "uint8",
      },
    ],
    name: "Initialized",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "previousOwner",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "newOwner",
        type: "address",
      },
    ],
    name: "OwnershipTransferred",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "Paused",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        indexed: true,
        internalType: "bytes32",
        name: "previousAdminRole",
        type: "bytes32",
      },
      {
        indexed: true,
        internalType: "bytes32",
        name: "newAdminRole",
        type: "bytes32",
      },
    ],
    name: "RoleAdminChanged",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        indexed: true,
        internalType: "address",
        name: "account",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "sender",
        type: "address",
      },
    ],
    name: "RoleGranted",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        indexed: true,
        internalType: "address",
        name: "account",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "sender",
        type: "address",
      },
    ],
    name: "RoleRevoked",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "from",
        type: "address",
      },
      {
        indexed: false,
        internalType: "string",
        name: "banAddress",
        type: "string",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
    ],
    name: "SwapToBan",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "from",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "value",
        type: "uint256",
      },
    ],
    name: "Transfer",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "Unpaused",
    type: "event",
  },
  {
    inputs: [],
    name: "DEFAULT_ADMIN_ROLE",
    outputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "DOMAIN_SEPARATOR",
    outputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "MINTER_ROLE",
    outputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "PAUSER_ROLE",
    outputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "owner",
        type: "address",
      },
      {
        internalType: "address",
        name: "spender",
        type: "address",
      },
    ],
    name: "allowance",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "spender",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
    ],
    name: "approve",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "balanceOf",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "decimals",
    outputs: [
      {
        internalType: "uint8",
        name: "",
        type: "uint8",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "spender",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "subtractedValue",
        type: "uint256",
      },
    ],
    name: "decreaseAllowance",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "getOwner",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
    ],
    name: "getRoleAdmin",
    outputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "grantRole",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "hasRole",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "spender",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "addedValue",
        type: "uint256",
      },
    ],
    name: "increaseAllowance",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "initialize",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "initializeWithPermit",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "recipient",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "uuid",
        type: "uint256",
      },
    ],
    name: "isReceiptConsumed",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "recipient",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "uuid",
        type: "uint256",
      },
      {
        internalType: "uint8",
        name: "v",
        type: "uint8",
      },
      {
        internalType: "bytes32",
        name: "r",
        type: "bytes32",
      },
      {
        internalType: "bytes32",
        name: "s",
        type: "bytes32",
      },
    ],
    name: "mintWithReceipt",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "name",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "owner",
        type: "address",
      },
    ],
    name: "nonces",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "owner",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "pause",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "paused",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "owner",
        type: "address",
      },
      {
        internalType: "address",
        name: "spender",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "value",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "deadline",
        type: "uint256",
      },
      {
        internalType: "uint8",
        name: "v",
        type: "uint8",
      },
      {
        internalType: "bytes32",
        name: "r",
        type: "bytes32",
      },
      {
        internalType: "bytes32",
        name: "s",
        type: "bytes32",
      },
    ],
    name: "permit",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "renounceOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "renounceRole",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "revokeRole",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes4",
        name: "interfaceId",
        type: "bytes4",
      },
    ],
    name: "supportsInterface",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "string",
        name: "bananoAddress",
        type: "string",
      },
      {
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
    ],
    name: "swapToBan",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "symbol",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "totalSupply",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
    ],
    name: "transfer",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "from",
        type: "address",
      },
      {
        internalType: "address",
        name: "to",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
    ],
    name: "transferFrom",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "newOwner",
        type: "address",
      },
    ],
    name: "transferOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "unpause",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
];

const _bytecode =
  "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";

type WBANTokenWithPermitConstructorParams =
  | [signer?: Signer]
  | ConstructorParameters<typeof ContractFactory>;

const isSuperArgs = (
  xs: WBANTokenWithPermitConstructorParams
): xs is ConstructorParameters<typeof ContractFactory> => xs.length > 1;

export class WBANTokenWithPermit__factory extends ContractFactory {
  constructor(...args: WBANTokenWithPermitConstructorParams) {
    if (isSuperArgs(args)) {
      super(...args);
    } else {
      super(_abi, _bytecode, args[0]);
    }
  }

  override deploy(
    overrides?: Overrides & { from?: PromiseOrValue<string> }
  ): Promise<WBANTokenWithPermit> {
    return super.deploy(overrides || {}) as Promise<WBANTokenWithPermit>;
  }
  override getDeployTransaction(
    overrides?: Overrides & { from?: PromiseOrValue<string> }
  ): TransactionRequest {
    return super.getDeployTransaction(overrides || {});
  }
  override attach(address: string): WBANTokenWithPermit {
    return super.attach(address) as WBANTokenWithPermit;
  }
  override connect(signer: Signer): WBANTokenWithPermit__factory {
    return super.connect(signer) as WBANTokenWithPermit__factory;
  }

  static readonly bytecode = _bytecode;
  static readonly abi = _abi;
  static createInterface(): WBANTokenWithPermitInterface {
    return new utils.Interface(_abi) as WBANTokenWithPermitInterface;
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): WBANTokenWithPermit {
    return new Contract(address, _abi, signerOrProvider) as WBANTokenWithPermit;
  }
}
